import { Link } from "react-router-dom";

export default function AuthShell({ eyebrow, title, children }) {
  return (
    <div className="relative grid min-h-screen place-items-center px-4 py-12 grain">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="relative z-10 w-full max-w-md rise">
        <Link to="/" className="mb-8 flex justify-center" data-testid="auth-logo-link">
          <img src="/korevex-logo.png" alt="Korevex Bio" className="h-28 w-auto object-contain drop-shadow-[0_0_30px_rgba(56,189,248,0.2)] sm:h-36" data-testid="auth-logo" />
        </Link>
        <div className="rounded-lg border border-border bg-card/80 p-8 backdrop-blur-xl">
          <p className="eyebrow mb-2">{eyebrow}</p>
          <h1 className="mb-6 text-2xl font-semibold">{title}</h1>
          {children}
        </div>
      </div>
    </div>
  );
}
